
import CartCommodityItem from '@/classes/CartCommidityItem';
import {
  defineComponent,
  computed,
} from 'vue';
import { useStore } from 'vuex';
import CartItem from '@/components/cart/CartItem.vue';

export default defineComponent({
  components: {
    CartItem,
  },

  emits: ['remove'],

  setup() {
    const store = useStore();

    const cartCommodity = computed<Array<CartCommodityItem>>(() => store.getters['cart/commodity']);

    return {
      cartCommodity,
    };
  },
});
